import React, { useState, useEffect } from "react";
import { Spinner } from "react-bootstrap";
import "./objetivos.css";
import { getStaticUrl } from "../../../../../utils/getStaticUrl";
import { getJsonFromStorage } from "../../../../../utils/getJsonFromStorage";

function Objetivos() {
  const [odsImages, setOdsImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchImages = async () => {
      const jsonData = await getJsonFromStorage("objetivos.json");
      if (jsonData && jsonData.images) {
        setOdsImages(jsonData.images.map(getStaticUrl));
      } else {
        setError(true);
      }
      setLoading(false);
    };

    fetchImages();
  }, []);

  if (loading) {
    return (
      <div className="banner-loading">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }
  if (error) {
    return (
      <div className="banner-loading">
        <Spinner animation="border" variant="primary" />
        No fue posible cargar la información.
      </div>
    );
  }

  return (
    <>
      <div id="nos_ods">
        <ul>
          {odsImages.map((image, index) => (
            <li key={index}>
              <img src={image} alt={`Objetivo ${index + 1}`} />
            </li>
          ))}
        </ul>
      </div>
    </>
  );
}

export default Objetivos;
